const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const {PortalDestination} = require("../view/PortalDestination");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");

const Bundles = require("../Bundles");
const withBundleLoading = require("../hoc/withBundleLoading");
const withVaultUpdate = require("../hoc/withVaultUpdate");
const PageComponent = require("./PageComponent");
const LoadingCircle = require("../view/LoadingCircle");
const ScreenWarning = require("../view/ScreenWarning");
const {
	atPage,
	atUser,
	atCart,
	atParentAccount,
} = require("../vault/StateCursors");
const OpsPage = require("../vault/OpsPage");

const styles = require("./styles/MainOfficeContainer.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withBundleLoading(Component);
	Component = withVaultUpdate(Component, (props, vaultState) => ({
		page: atPage(vaultState).get(),
		user: atUser(vaultState).get(),
		cart: atCart(vaultState).get(),
		account: atParentAccount(vaultState).get(),
		connected: vaultState.connected,
		screenWarning: vaultState.screenWarning,
	}));
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "MainOfficeContainer",

		propTypes: {
			// Injected by HOCs
			page: PT.object.isRequired,
			user: PT.object.isRequired,
			cart: PT.object,
			account: PT.object,
			connected: PT.bool.isRequired,
			screenWarning: PT.string,

			requireOrLoadBundle: PT.func.isRequired,
		},

		UNSAFE_componentWillMount: function() {
			if (global.document) {
				document.documentElement.style.fontSize = "12px";
			}
		},

		componentDidMount: function() {
			// In case this class didn't get removed from MainTrainerContainer on unmount due to non-existence of document.body?
			// See https://github.com/aops-ba/ba/pull/2563
			global.document &&
				document.body &&
				document.body.classList.remove("no-bounce");
		},

		shouldBlockPage: function() {
			// TODO: Is there some way we can put this logic in the office bundle?
			// Maybe with a gateway?
			const {cart, account} = this.props;

			const OfficeBundle = Bundles.requireOpt("office");
			if (OfficeBundle) {
				if (OfficeBundle.OpsCart.shouldBlockPage(cart)) return true;
			}

			const ParentBundle = Bundles.requireOpt("parent");
			if (ParentBundle && account) {
				if (ParentBundle.OpsParentAcc.shouldBlockPage(account)) return true;
				if (ParentBundle.OpsParentSubChange.shouldBlockPage(account))
					return true;
			}

			return false;
		},

		render: function() {
			// The 404 page is very lightweight and is server-side rendered with
			// minimal Javascript. So we disable some TopBar and BottomBar elements
			// that require Javascript interaction.
			const {page, cart, user} = this.props;
			const noJS = process.env.IS_NODE && page.name === "404";

			const OfficeBundle = this.props.requireOrLoadBundle("office");

			const topBar = OfficeBundle ? (
				<OfficeBundle.TopBar noJS={noJS} cart={cart} page={page} user={user} />
			) : null;
			const bottomBar = OfficeBundle ? (
				<OfficeBundle.BottomBar noJS={noJS} page={page} />
			) : null;
			const changePasswordModal = OfficeBundle ? (
				<OfficeBundle.ChangePasswordModal />
			) : null;
			const emailModal = OfficeBundle ? (
				<OfficeBundle.EmailModal startOpen={page && page.openEmailModal} />
			) : null;
			const browserModal = OfficeBundle ? <OfficeBundle.BrowserModal /> : null;
			const errorModal = OfficeBundle ? <OfficeBundle.ErrorModal /> : null;
			const disconnectModal = OfficeBundle ? (
				<OfficeBundle.DisconnectModal />
			) : null;
			const cartModal = OfficeBundle ? <OfficeBundle.CartModal /> : null;
			const messageModal = OfficeBundle ? <OfficeBundle.MessageModal /> : null;
			const cancelSubscriptionModal = OfficeBundle ? (
				<OfficeBundle.CancelSubscriptionModal />
			) : null;
			const confirmModal = OfficeBundle ? <OfficeBundle.ConfirmModal /> : null;

			let loadingView;
			const mainStyle = {};

			const blockPage = this.shouldBlockPage();
			if (blockPage) {
				mainStyle.pointerEvents = "none";
				mainStyle.opacity = 0.3;

				loadingView = (
					<div className={styles.loading}>
						<LoadingCircle colorType="color" />
					</div>
				);
			}

			const vaultProps = _.pick(this.props, ["page", "user", "connected"]);

			const screenWarning = this.props.screenWarning;
			const mainEl =
				screenWarning && screenWarning !== "ignore" ? (
					<ScreenWarning isOffice={true} warning={screenWarning} />
				) : (
					<PageComponent
						additionalBundles={OfficeBundle ? [] : ["office"]}
						scrollToTopWhenNewPage={true}
						{...vaultProps}
					/>
				);

			let containerClass = styles.container;
			if (OpsPage.isMinWidthPage(page)) {
				containerClass = styles.minContainer;
			}

			if (page.forPrint) {
				// Add global .forPrint class
				return <div className={styles.main + " forPrint"}>{mainEl}</div>;
			}

			if (page.name === "parent.studentPrimaryRegistration") {
				// Onboarding: fullscreen immersive experience — no TopBar, BottomBar, or argyle bg.
				// Still mount error/disconnect modals so system-level alerts still work.
				return (
					<div className={styles.main}>
						{mainEl}
						{errorModal}
						{disconnectModal}
						{confirmModal}
					</div>
				);
			}

			const bgStyle =
				OpsPage.isPageCheckout(page) && page.step !== "confirm"
					? styles.bg
					: styles.bgArgyle;

			return (
				<div className={styles.main}>
					{loadingView}
					<div className={containerClass} style={mainStyle}>
						{topBar}
						<div className={styles.content}>
							<div className={bgStyle} />
							{mainEl}
						</div>
						{bottomBar}
						{cartModal}
						<PortalDestination name={PORTAL_CONTAINERS.MENU} />
						<PortalDestination name={PORTAL_CONTAINERS.EDITABLE_MODAL} />
						<PortalDestination
							name={PORTAL_CONTAINERS.EDITABLE_MODAL_CONFIRM}
						/>
					</div>
					<PortalDestination name={PORTAL_CONTAINERS.HOVER_TEXT} />
					<PortalDestination name={PORTAL_CONTAINERS.BUTTON_WITH_CONFIRM} />
					<PortalDestination name={PORTAL_CONTAINERS.INFO_MODAL} />
					<PortalDestination name={PORTAL_CONTAINERS.ASSIGNED_BLOCKS_MODAL} />
					<PortalDestination
						name={PORTAL_CONTAINERS.SCHEDULE_PUZZLE_LAB_MODAL}
					/>
					{changePasswordModal}
					{emailModal}
					{messageModal}
					{cancelSubscriptionModal}
					{disconnectModal}
					{errorModal}
					{browserModal}
					{confirmModal}
				</div>
			);
		},
	})
);
